<template>
  <ButtonDownload
    v-if="methodologyFileInfo"
    :data-filename="reportName"
    class="mx-0 !w-full !text-sm lg:!min-w-[150px] lg:!max-w-[150px]"
    :download-file="methodologyFileInfo"
    variant="secondary"
    text="Methodology"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ButtonDownload from '~/components/shared/common/ButtonDownload.vue'
import type { TDownloadFile } from '~/types/benchmark-app.type'

const props = withDefaults(
  defineProps<{
    methodologyFileInfo?: TDownloadFile
  }>(),
  {
    methodologyFileInfo: null,
  },
)

const reportName = computed(() => props.methodologyFileInfo?.file_name)
</script>
